import {
    Component,
    forwardRef,
    inject,
    Input,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { IMapComponent } from "../../../map.models";
import { IWidgetMenuButton } from "../../../map.settings";
import { MapBaseSubComponent } from "../map-base-sub-component/map-base-sub.component";

@Component({
    selector: "rask-map-abort-draw",
    templateUrl: "./map-abort-draw.component.html",
    styleUrls: ["./map-abort-draw.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        { provide: MapBaseSubComponent,
            useExisting: forwardRef(() => MapAbortDrawComponent) }
    ]
})
export class MapAbortDrawComponent extends MapBaseSubComponent implements OnInit {
    readonly authService = inject(AuthenticationService);

    isDrawing = false;
    widgetId = "map-abort-draw";
    buttons = [
{
    iconClass: "fa-times",
    tooltipText: "Avbryt redigering",
    customButtonClass: "highlight-tool",
    visible: () => this.isDrawing && this.authService.canEdit(),
    widgetId: this.widgetId,
    click: () => { this.abort(); }
} as IWidgetMenuButton
    ];

    isEnabled = true;
    map: IMapComponent;
    @Input()
    set enabled(value: boolean) {
        this.isEnabled = value;
    }
    get enabled() {
        return this.isEnabled;
    }
    constructor() {
        super();
        this.setupEvents();
    }

    ngOnInit(): void {
        this.mapReady.pipe(
            takeUntil(this.destroy$)
        ).subscribe(instance => {
            this.map = instance;
            this.setupEvents();
        });
    }

    setupEvents() {
        this.map?.getSketch().onStateChange.pipe(
            takeUntil(this.destroy$)
        ).subscribe((state) => {
            this.setIsDrawing(state);
        });
    }

    setIsDrawing(state) {
        this.isDrawing = (state === "active");
    }

    abort() {
        this.map?.getSketch().cancelSketch();
    }

}
